module.exports = __webpack_public_path__ + "static/media/night.e3d03ada.svg";